import type { FC } from "react";
import styled, { useTheme } from "styled-components";

import { Button, ButtonVariant, Flex, Icon, Icons, Text } from "src/components";
import { useTranslation } from "src/translations";
import { DATE_YEAR_FORMAT, getEndOfWeek, getOffsetDate, localeFormat, useAppDispatch, useAppSelector } from "src/utils";
import { setNextWeek, setPreviousWeek, setThisWeek } from "../actions";
import { getWeekOffset } from "../selectors";
import { useFirstDayOfWeek } from "../utils";

export const Controls: FC = () => {
    const { t } = useTranslation();
    const { color, fontWeight } = useTheme();

    const dispatch = useAppDispatch();
    const firstDayOfWeek = useFirstDayOfWeek();
    const weekOffset = useAppSelector(getWeekOffset);

    const from = localeFormat(getOffsetDate(firstDayOfWeek, 0, weekOffset), DATE_YEAR_FORMAT);
    const to = localeFormat(getEndOfWeek(getOffsetDate(firstDayOfWeek, 0, weekOffset)), DATE_YEAR_FORMAT);

    return (
        <Flex flexDirection="row" alignItems="center" gap="1rem">
            <Button onClick={() => dispatch(setThisWeek())} variant={ButtonVariant.Filled}>
                {t("thisWeek")}
            </Button>
            <StyledWeekNavigation>
                <Icon
                    color={color.blue100}
                    icon={Icons.ArrowLeft}
                    onClick={() => dispatch(setPreviousWeek())}
                    height={25}
                    width={25}
                    alt={t("dashboard.previousWeek")}
                />
                <Text color={color.azure} weight={fontWeight._600}>{`${from} - ${to}`}</Text>
                <Icon
                    color={color.blue100}
                    icon={Icons.ArrowRight}
                    onClick={() => dispatch(setNextWeek())}
                    height={25}
                    width={25}
                    alt={t("dashboard.nextWeek")}
                />
            </StyledWeekNavigation>
        </Flex>
    );
};

const StyledWeekNavigation = styled.div`
    display: flex;
    align-items: center;
    border: ${({ theme }) => `1px solid ${theme.color.gray50}`};
    border-radius: ${({ theme }) => theme.borderRadius._5};
    gap: 0.25rem;
    padding: 0.5rem;
`;
